import React, {useState} from "react";

import { EventPlatformEntry } from "@mediaspace/shared/types";
import { Carousel, slickClasses } from "@mediaspace/shared/ui";
import NewsItem from "./NewsItem";
import styled from "@emotion/styled";

interface Props {
    entries: EventPlatformEntry[];
    modalBoxMaskColor?: string;
}

const StyledContainer = styled("div")(({ theme }) => ({
    width: "100%",
    paddingTop: 60,
    paddingBottom: 60,
    backgroundColor: theme.kaltura.palette.tone7,
    [`& .${slickClasses.slide} div`]: {
        // needed for truncation
        width: "100%",
    },
    [theme.breakpoints.down(theme.breakpoints.values.lg - 0.05)]: {
        paddingTop: 40,
        paddingBottom: 40,
    },
}));

/**
 * News Component displays news playlist in a carousel
 */
export const News = (props: Props) => {
    const { entries, modalBoxMaskColor } = props;

    // activeModal holds the id of the current open modal, as a workaround for the issue where
    // the slick-carousel package unmounts the NewsItem when resizing from lg to md or from sm to md
    // screen size. when the component unmounts it loses its modal state, so it's being kept here.
    const [activeModal, setActiveModal] = useState<string>("");

    return (
        <StyledContainer id="kms-ds-homepage-component-news">
            <Carousel
                items={entries}
                currentCardsNumberInSlides={3}
                itemComponent={NewsItem}
                itemProps={{
                    modalBoxMaskColor,
                }}
                activeModal={activeModal}
                setActiveModal={setActiveModal}
                container={"News Item"}
            />
        </StyledContainer>
    );
};

export default News;
